/**
 * Boot-time config merger.
 *
 *   CONFIG = { ...SHARED, games: { frogger, snake, pipeline } }
 *
 * Exposed on `window.CONFIG` for debugging and consumed by SkinResolver.
 * Plain JS, no schema, no validation — by design.
 */

import { SHARED_CONFIG, SHARED_GAME } from './shared.config.js';
import { FROGGER } from './frogger.config.js';
import { SNAKE } from './snake.config.js';
import { PIPELINE } from './pipeline.config.js';
import { TRAINSIM } from './trainsim.config.js';
import { PLATFORMER } from './platformer.config.js';

export const CONFIG = {
    ...SHARED_CONFIG,
    games: {
        // Pseudo-game holding cross-game settings (visual filters etc.).
        // Listed first so any iteration that hits `Object.keys(games)`
        // sees it before the playable games — purely cosmetic.
        shared: SHARED_GAME,
        frogger: FROGGER,
        snake: SNAKE,
        pipeline: PIPELINE,
        trainsim: TRAINSIM,
        platformer: PLATFORMER,
    },
};

if (typeof window !== 'undefined') {
    window.CONFIG = CONFIG;
}
